import type { ReactNode } from 'react';

import clsx from 'clsx';

import FiltersDisclosure from './FiltersDisclosure';

interface FilterSectionProps {
  title: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Rendered as a count badge. Omitted/0 shows no badge. */
  selectedCount?: number;
  /** Rendered instead of a count — used by range filters (e.g. "1-5 TiB"). */
  badgeLabel?: string;
  onClear: () => void;
  children: ReactNode;
  className?: string;
}

/**
 * The shell every filter-panel section shares: padding, bottom divider, count-or-label badge
 * and a clear affordance. Promoted from exploration's `FilterCheckboxDisclosure` so
 * fleet-manager's panel can use the identical shell.
 */
export default function FilterSection({
  title,
  open,
  onOpenChange,
  selectedCount = 0,
  badgeLabel,
  onClear,
  children,
  className,
}: FilterSectionProps) {
  return (
    <FiltersDisclosure
      title={title}
      count={selectedCount > 0 ? selectedCount : undefined}
      badgeLabel={badgeLabel}
      className={clsx('px-8 border-b border-gray-300', className)}
      open={open}
      onOpenChange={onOpenChange}
      onClearFilters={onClear}
    >
      {children}
    </FiltersDisclosure>
  );
}
